<template>
  <div
    class="column-view"
    :class="{
      disabled,
      flipped:
        columnConfiguration &&
        columnConfiguration.jibCrane &&
        columnConfiguration &&
        columnConfiguration.jibCrane.placement == 'RIGHT',
    }"
  >
    <div :class="{ sides: true, 'two-columns': sides.length <= 2 }">
      <div
        :class="
          columnConfiguration && columnConfiguration.jibCrane
            ? 'side mx-5'
            : 'side'
        "
        :style="
          side == 'REAR' && sides.length > 2
            ? 'padding-right: 100px; border-right: 1px solid rgba(0, 0, 0, 0.6);'
            : side == 'LEFT'
              ? 'margin-left: 25px;'
              : ''
        "
        v-for="side in sides"
        :key="side"
      >
        <div class="label">{{ $t("columnside." + side) }}</div>
        <div v-if="!$store.getters['projects/disabled']" class="controls">
          <div variant="link" class="resize" @click="$emit('changeHeightOfMediacolumn', 'plus')">＋</div>
          <div variant="link" class="resize" @click="$emit('changeHeightOfMediacolumn', 'minus')">－</div>
        </div>
        <div
          class="column"
          ref="columns"
          @dragenter="$event.preventDefault()"
          @dragover="onDragOver($event, side)"
          @dragleave="onDragLeave"
          @drop="onDrop"
          @dragend="$emit('dragEnd', $event)"
          :style="{
            height: `${columnConfiguration.height}px`,
            '--url-m': `url('/img/column/${columnImg}_middle.png')`,
            '--url-l': `url('/img/column/${columnImg}_lower.png')`,
            '--url-h': `url('/img/column/${columnImg}_upper.png')`,
            '--module-width': `${moduleWidth}px`,
            '--width': `${columnType.widthX}px`,
          }"
        >
          <div
            class="module"
            v-for="p in [...placements, hoverPlacement].filter(
              (p) => p && p.side == side
            )"
            :key="p.id + p.gridIndex"
            :id="p.id.toString()"
            :class="{
              hover: p == hoverPlacement,
              invalid: isInvalid(p),
              empty: p.automatic,
              isEmpty: p.module.type == 'EMPTY',
              selected: p.id == selectedPlacement
            }"
            draggable
            @click.stop="$emit('selectPlacement', p.id, $event.currentTarget)"
            @dragstart="onDragStart($event, p)"
            @dragenter.prevent
            :style="{
              height: `${(p.module.slotHeight || 1) * 125}px`,
              bottom: `${p.gridIndex * 125}px`,
              opacity:
                p.id == ((dragItem && dragItem.placement) || {}).id ||
                  (p == hoverPlacement && !forbiddenToDrop)
                  ? '0'
                  : null,
              '--img-url': `url('/img/modules/empty_module_${emptyModuleImg}.png')`,
            }"
          >
            <div v-if="p.module.type == 'EMPTY'" class="empty" />
            <img v-else :src="`${moduleImageUrl(p.module)}_flat`" />
            <b-tooltip
              v-if="
                p == hoverPlacement &&
                isInvalid(p) &&
                !positionIsIdenticalWithPlacement(p)
              "
              no-fade
              variant="danger"
              :target="p.id.toString()"
              :show="true"
            >
              {{
                $t("configuration.invalidPlacementCollision")
              }}
            </b-tooltip>
          </div>

          <div
            class="measure"
            v-for="i in columnConfiguration.height / 125"
            :style="{ bottom: i * 125 + 'px' }"
            :key="i"
          >{{ i * 125 }} mm</div>
          <div
            class="crane"
            v-if="
              side == 'FRONT' &&
              columnConfiguration &&
              columnConfiguration.jibCrane
            "
            :style="{
              height: jibCraneSpan + 'px',
              bottom: columnConfiguration.jibCrane.height + 'px',
            }"
          >
            <div
              :class="
                columnConfiguration.jibCrane.placement == 'LEFT'
                  ? 'edit-left-jib-crane'
                  : ''
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jibCraneSpan } from "../../jibCrane";

const SIDES_ORDER = {
  FRONT: 0,
  REAR: 1,
  LEFT: 2,
  RIGHT: 3,
};

export default {
  props: {
    columnType: Object,
    columnConfiguration: Object,
    modulePlacements: Array,
    emptyModules: Array,
    modulePriceHover: String,
    disabled: Boolean,
    dragItem: Object,
    selectedPlacement: null
  },
  data() {
    return {
      hoverPlacement: null,
    };
  },
  computed: {
    jibCraneSpan() {
      return jibCraneSpan();
    },
    sides() {
      if (this.columnType == null || this.columnType.arableSites == null)
        return [];
      return [...this.columnType.arableSites].sort(
        (a, b) => SIDES_ORDER[a] - SIDES_ORDER[b]
      );
    },
    columnImg() {
      return {
        XXS4: "xxs4",
        XS2: "s4",
        S4: "s4",
        "M2+": "m2",
        "L2+": "l2",
      }[this.columnType.id];
    },
    emptyModuleImg() {
      return {
        XXS4: "xxs",
        XS2: "xs_s",
        S4: "xs_s",
        "M2+": "m_l",
        "L2+": "m_l",
      }[this.columnType.id];
    },
    moduleWidth() {
      return {
        XXS4: 84,
        XS2: 129,
        S4: 129,
        "M2+": 120,
        "L2+": 120
      }[this.columnType.id]
    },
    forbiddenToDrop() {
      return this.$store.state.configurations.forbiddenToDrop;
    },
    placements() {
      if (this.$store.state.modules.length == 0) return []
      return this.modulePlacements.map((p) => ({
        ...p.position,
        id: p.id,
        automatic: p.automatic,
        module: this.$store.state.modules.find(
          (m) => m.itemNumber == p.itemNumber
        ),
      }));
    },
  },
  methods: {
    positionIsIdenticalWithPlacement(placement) {
      return (
        placement.gridIndex + placement.module.slotHeight >
        this.$store.state.configurations.configuration.height / 125 ||
        this.placements.some(
          (other) =>
            !other.automatic &&
            other.side == placement.side &&
            placement.gridIndex < other.gridIndex + other.module.slotHeight &&
            placement.gridIndex + placement.module.slotHeight > other.gridIndex
        )
      );
    },
    isInvalid(placement) {
      if (this.hoverPlacement && this.hoverPlacement.invalid) {
        if (this.forbiddenToDrop == null) return false;
        if (
          this.hoverPlacement.invalid.collidesWith.find(
            (p) =>
              p.position.gridIndex == placement.gridIndex &&
              p.position.side == placement.side
          )
        ) {
          return true;
        }
      }
      return placement.invalid != null;
    },
    moduleImageUrl(module) {
      return `${process.env.VUE_APP_API}/modules/${module.itemNumber}/image`;
    },
    async onDragStart(event, placement) {

      if (this.$store.getters["projects/disabled"]) return;

      //center drag image (fixes offset issue in firefox)
      event.dataTransfer.setDragImage(
        event.target,
        event.target.offsetWidth / 2,
        event.target.offsetHeight / 2
      );

      this.$emit("dragStart", { event, module: placement.module, placement });
    },
    onDragOver(event, side) {
      if (!this.dragItem || this.dragItem.module.mountingArea == "HEAD") return;
      event.preventDefault();

      if (!this.hoverPlacement) {
        this.hoverPlacement = {
          id: Math.random(),
          gridIndex: 0,
          side,
          module: this.dragItem.module,
        };
      }
      
        const rect = this.$refs.columns[0].getBoundingClientRect();
      const scale = rect.width / this.$refs.columns[0].offsetWidth;
      const offset = this.dragItem.offset || 0
      
      this.hoverPlacement.gridIndex = Math.min(
        Math.max(Math.round(
          (this.columnConfiguration.height - (event.clientY - rect.y + offset) / scale) / 125
        ), 0),
        this.columnConfiguration.height / 125 - this.hoverPlacement.module.slotHeight
      );

      this.$set(
        this.hoverPlacement,
        "invalid",
        this.forbiddenToDrop
          ? this.forbiddenToDrop.find(
            (p) =>
              p.placement.position.gridIndex ==
              this.hoverPlacement.gridIndex &&
              p.placement.position.side == this.hoverPlacement.side
          )
          : { collidesWith: [] }
      );
    },
    onHover(event, side) {
      const rect = this.$refs.columns[0].getBoundingClientRect();
      const scale = rect.width / this.$refs.columns[0].offsetWidth;
      const offset = this.dragItem.offset || 0
      const gridIndex = Math.floor(
        (this.columnConfiguration.height - (event.clientY - rect.y + offset) / scale) /
        125
      );

      if (this.hoverPlacement == null || this.hoverPlacement.module == null) {

        this.hoverPlacement = {
          id: Math.random(),
          gridIndex,
          side,
          module: null,
        };
      }

    },
    onDragLeave() {
      this.hoverPlacement = null;
    },
    async onDrop(event) {
      event.preventDefault();

      if (this.hoverPlacement && !this.hoverPlacement.invalid) {
        if (this.dragItem.placement) {
          this.$store.commit(
            "configurations/deleteModulePlacement",
            this.dragItem.placement
          );
        }

        this.$store.commit("configurations/addModulePlacement", {
          position: {
            ...this.hoverPlacement,
            id: undefined,
            invalid: undefined,
            module: undefined,
          },
          itemNumber: this.hoverPlacement.module.itemNumber,
        });
      }
      this.hoverPlacement = null;
      this.$emit("dragEnd", event)
    },
  },
  mounted() {
    this.$watch(
      () => this.forbiddenToDrop,
      () => {
        if (!this.hoverPlacement) return;
        this.$set(
          this.hoverPlacement,
          "invalid",
          this.forbiddenToDrop
            ? this.forbiddenToDrop.find(
              (p) =>
                p.placement.position.gridIndex ==
                this.hoverPlacement.gridIndex &&
                p.placement.position.side == this.hoverPlacement.side
            )
            : { collidesWith: [] }
        );
      }
    );
  },
};
</script>

<style scoped>
.edit-left-jib-crane {
  text-align: left;
}

.column-view {
  position: relative;
  display: flex;
  margin: 40px auto 20px auto;
  flex-direction: column;
}

.sides {
  position: relative;
  flex-grow: 1;
  display: flex;
  /* padding: 0 40px; */
  margin: 0 auto;
}

.side {
  margin: 0 auto;
  padding: 0 65px 10px 65px;
}
.two-columns .side {
  padding: 0 100px 10px 100px;
}
.label {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.6);
}

.column {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: var(--width);
  margin: 0 auto 16px;
}

.column-view.disabled .column {
  pointer-events: none;
}

.column::before,
.column::after {
  content: "";
  position: absolute;
  width: 375px;
  top: -50px;
  bottom: -50px;
  pointer-events: none;
}

.column::before {
  top: 0;
  bottom: 0;
  background: center / auto 100px var(--url-m) repeat-y;
}

.column::after {
  background: top center / auto 100px var(--url-h) no-repeat,
    bottom center / auto 100px var(--url-l) no-repeat;
}

.module {
  cursor: grab;
  z-index: 1;
  position: absolute;
  width: var(--module-width);
  height: 125px;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  transition: bottom 100ms, opacity 100ms, box-shadow 200ms, outline-color 200ms;
  outline: 2px solid transparent;
  outline-offset: 2px;
  display: flex;
  align-items: center;
  touch-action: none;
}

.module::after {
  content: "";
  position: absolute;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-top: none;
  pointer-events: none;
}

.module img {
  display: block;
  width: 100%;
  pointer-events: none;
  /* user-select: none; */
}

.module.hover {
  z-index: 2;
  pointer-events: none;
  user-select: none;
  outline: 2px dashed rgba(0, 3, 9, 0.2);
  outline-offset: 0;
  background: rgba(40, 102, 235, 0.4);
}

.module.selected {
  outline: 2px solid #28d;
  outline-offset: 2px;
  z-index: 10;
  border-radius: 1px;
}

.module.hover img {
  /* filter: grayscale(100%); */

  opacity: 0.4;
}

.module.invalid::after {
  background: rgba(200, 60, 60, 0.5);
}

.empty.module {
  pointer-events: none;
  user-select: none;
}

.empty.module img {
  opacity: 0.3;
}
.measure {
  user-select: none;
  position: absolute;
  right: -6px;
  transform: translateX(100%);
  margin-bottom: -5px;
  font-size: 15px;
  line-height: 1;
}

.flipped .measure {
  right: auto;
  left: -6px;
  transform: translateX(-100%);
}

.measure.bottom {
  top: auto;
  bottom: -4px;
}

.crane {
  position: absolute;
  left: 0;
  transform: translateX(-100%);
  width: 145px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  text-align: right;
}

.crane::before,
.crane::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: bottom left / auto 200px url("/img/column/mounting_angle.png")
    no-repeat;
  transform: scaleX(-1);
  z-index: -1;
}

.crane::after {
  transform: scaleX(-1) scaleY(-1);
}

.flipped .crane {
  left: auto;
  text-align: left;
  right: 0;
  transform: translateX(100%);
}

.flipped .crane::before {
  transform: scaleX(1);
}

.flipped .crane::after {
  transform: scaleX(1) scaleY(-1);
}

.crane .measure {
  transform: translateX(0);
  right: 0;
}

.controls {
  border: 2px dashed rgba(0, 0, 0, 0.2);
  border-bottom: none;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.resize {
  cursor: pointer;
  user-select: none;
  padding: 8px;
  font-size: 28px;
  color: rgba(0, 0, 0, 0.4);
  text-decoration: none;
}

.resize:hover {
  color: rgba(0, 0, 0, 0.8);
}

.module .empty::before,
.module .empty::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 25px;
  background: no-repeat 0 0 / 100% auto var(--img-url);
}

.module .empty::before {
  top: 0;
  background-position: top;
}

.module .empty::after {
  bottom: 0;
  background-position: bottom;
}
</style>
